
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2017-08-06-when-is-golden-hour",
      function () {
        return require("private-next-pages/posts/2017-08-06-when-is-golden-hour.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2017-08-06-when-is-golden-hour"])
      });
    }
  